import uniqueId from 'lodash/uniqueId'
import React from 'react'
import { useRadioGroup } from '../RadioGroup/useRadioGroup'
import * as styles from './styles'

type RadioInputProps = {
  disabled?: boolean
  label: string
  value: string
}
export const RadioInput = React.forwardRef<HTMLInputElement, RadioInputProps>(
  ({ value, label, disabled }, inputRef) => {
    const id = React.useMemo(() => uniqueId('radio-input'), [])
    const { name, onChange, value: groupValue, theme } = useRadioGroup()

    return (
      <div css={styles.wrapper({ theme })}>
        <input
          css={styles.input({ theme })}
          checked={value === groupValue}
          disabled={disabled}
          id={id}
          name={name}
          onChange={onChange}
          ref={inputRef}
          type="radio"
          value={value}
        />
        <label htmlFor={id} style={{ cursor: 'pointer' }}>
          {label}
        </label>
      </div>
    )
  }
)

RadioInput.displayName = 'Lapidary: Radio.Input'
